/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ActiveIncomingCall
 */
export interface ActiveIncomingCall {
  /**
   *
   * @type {string}
   * @memberof ActiveIncomingCall
   */
  dialpadCallId: string;
  /**
   *
   * @type {string}
   * @memberof ActiveIncomingCall
   */
  state: string;
  /**
   *
   * @type {string}
   * @memberof ActiveIncomingCall
   */
  externalNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof ActiveIncomingCall
   */
  contactName?: string | null;
  /**
   *
   * @type {string}
   * @memberof ActiveIncomingCall
   */
  companyId?: string | null;
  /**
   *
   * @type {string}
   * @memberof ActiveIncomingCall
   */
  companyName?: string | null;
  /**
   *
   * @type {string}
   * @memberof ActiveIncomingCall
   */
  salesContactId?: string | null;
  /**
   *
   * @type {string}
   * @memberof ActiveIncomingCall
   */
  companyNoteId?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof ActiveIncomingCall
   */
  startedAt: OffsetDateTime;
}

/**
 * Check if a given object implements the ActiveIncomingCall interface.
 */
export function instanceOfActiveIncomingCall(
  value: object,
): value is ActiveIncomingCall {
  if (!("dialpadCallId" in value) || value["dialpadCallId"] === undefined)
    return false;
  if (!("state" in value) || value["state"] === undefined) return false;
  if (!("startedAt" in value) || value["startedAt"] === undefined) return false;
  return true;
}

export function ActiveIncomingCallFromJSON(json: any): ActiveIncomingCall {
  return ActiveIncomingCallFromJSONTyped(json, false);
}

export function ActiveIncomingCallFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ActiveIncomingCall {
  if (json == null) {
    return json;
  }
  return {
    dialpadCallId: json["dialpadCallId"],
    state: json["state"],
    externalNumber:
      json["externalNumber"] == null ? undefined : json["externalNumber"],
    contactName: json["contactName"] == null ? undefined : json["contactName"],
    companyId: json["companyId"] == null ? undefined : json["companyId"],
    companyName: json["companyName"] == null ? undefined : json["companyName"],
    salesContactId:
      json["salesContactId"] == null ? undefined : json["salesContactId"],
    companyNoteId:
      json["companyNoteId"] == null ? undefined : json["companyNoteId"],
    startedAt: json["startedAt"],
  };
}

export function ActiveIncomingCallToJSON(json: any): ActiveIncomingCall {
  return ActiveIncomingCallToJSONTyped(json, false);
}

export function ActiveIncomingCallToJSONTyped(
  value?: ActiveIncomingCall | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    dialpadCallId: value["dialpadCallId"],
    state: value["state"],
    externalNumber: value["externalNumber"],
    contactName: value["contactName"],
    companyId: value["companyId"],
    companyName: value["companyName"],
    salesContactId: value["salesContactId"],
    companyNoteId: value["companyNoteId"],
    startedAt: value["startedAt"],
  };
}
